import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loadingInv: false,
  errorInv: null,
  invoices: [],
  invoice: null,
  pagination: {},
};

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setLoadingInv: (state) => {
      state.loadingInv = true;
    },
    resetLoading: (state) => {
      state.loadingInv = false;
    },
    setInvoices: (state, { payload }) => {
      state.loadingInv = false;
      state.errorInv = null;
      state.invoices = payload;
      state.invoice = null;
    },
    setInvoice: (state, { payload }) => {
      state.loadingInv = false;
      state.errorInv = null;
      if (payload && payload[0]) {
        state.invoice = payload[0];
      } else {
        state.invoice = payload;
      }
    },
    setInvoiceItems: (state, { payload }) => {
      state.loadingInv = false;
      state.errorInv = null;
      state.invoice = { ...state.invoice, items: payload.invoiceItems };
    },
    setErrorInv: (state, { payload }) => {
      state.loadingInv = false;
      state.errorInv = payload;
    },
    setPagination: (state, { payload }) => {
      state.loadingInv = false;
      state.errorInv = null;
      state.pagination = payload;
    },
  },
});

export const { setLoadingInv, resetLoading, setInvoices, setInvoice, setErrorInv, setPagination, setInvoiceItems } =
  invoicesSlice.actions;

export default invoicesSlice.reducer;

export const invoicesSelector = (state) => state.invoice;
